module.exports = __webpack_public_path__ + "static/AvenirNext-UltraLightItalic-1c2a26063a330bfc265d2016b5f1519d.woff";